import { generateId } from '@freelancer/datastore/testing/helpers';
import { DAY } from '@freelancer/ui/relative-time';
import type {
  AvailabilityMatching,
  MatchingAvailability,
} from './availability-matching.model';

export interface GenerateMatchingAvailabilityOptions {
  readonly id?: number;
  readonly userId?: number;
  readonly seoUrl?: string;
  readonly startLocationDisplay?: string;
  readonly preferredDestinations?: readonly string[];
  readonly startDateMin?: number;
  readonly endDateMax?: number;
  readonly vehicleTypes?: readonly string[];
  readonly isAlreadyInvited?: boolean;
  readonly matchScore?: number;
  readonly minimumBudget?: number;
  readonly description?: string;
}

export interface GenerateAvailabilityMatchingOptions {
  readonly projectId: number;
  readonly availabilities?: readonly GenerateMatchingAvailabilityOptions[];
}

export function generateMatchingAvailabilityObject({
  id = generateId(),
  userId = generateId(),
  seoUrl = `Semi-trailer-truck-available-${id}`,
  startLocationDisplay = 'Sydney, NSW',
  preferredDestinations = ['Melbourne, VIC'],
  startDateMin = Date.now() + DAY,
  endDateMax = Date.now() + DAY * 7,
  vehicleTypes = ['Semi-trailer'],
  isAlreadyInvited = false,
  matchScore = 0.9,
  minimumBudget,
  description,
}: GenerateMatchingAvailabilityOptions = {}): MatchingAvailability {
  return {
    id,
    userId,
    seoUrl,
    startLocationDisplay,
    preferredDestinations,
    startDateMin,
    endDateMax,
    vehicleTypes,
    isAlreadyInvited,
    matchScore,
    minimumBudget,
    description,
  };
}

export function generateAvailabilityMatchingObject({
  projectId,
  availabilities = [],
}: GenerateAvailabilityMatchingOptions): AvailabilityMatching {
  return {
    id: projectId,
    availabilities: availabilities.map(availability =>
      generateMatchingAvailabilityObject(availability),
    ),
  };
}
